import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { handleApproveRejectCreditNote, handleCreateCreditNoteChanges } from "../../commonHandlerFunction/Collections/CreditNoteHandler";
import { decryptDataForURL } from "../../../../utills/useCryptoUtils";
import { getCreditNoteStatus } from "../../../../services/commonFunction";

const CreditNoteButton = ({
  formData,
  handleSubmit,
  setIsOverlayLoader,
  viewOnly,
  setIsRejectPopupOpen
}) => {
  const hash = window.location.hash;
  const params = new URLSearchParams(hash.split("?")[1]);
  const action = decryptDataForURL(params.get("action"));
  const useFor = decryptDataForURL(params.get("useFor"));
  const onClickHandler = (type) => {
    handleCreateCreditNoteChanges(formData, setIsOverlayLoader, navigate, type);
  };
  const navigate = useNavigate();
  return (
    <div className="auditBtns">
      <Button
        type="button"
        className="cancelBtn"
        onClick={() => navigate("/collections/credit-notes")}
      >
        Back
      </Button>
      {!viewOnly && useFor != "approval" && (
        <>
          {(!formData[0]?.cn_status || getCreditNoteStatus(formData[0]?.cn_status) === "saved") && (
            <Button
              type="button"
              className="saveBtn"
              onClick={() => {
                let isValidate = handleSubmit();
                if (!isValidate) {
                return false;
              }
              onClickHandler("save");
            }}
          >
            Save
          </Button>)}
          {['CU','T10075','T10109'].includes(formData[0]?.cn_next_approval_role) && 
            <Button
            type="button"
            className="submitBtn"
            onClick={(e) => setIsRejectPopupOpen(true)}
          >
            Reject
          </Button>
          }
          <Button
            type="button"
            className="submitBtn"
            onClick={() => {
              let isValidate = handleSubmit();
              if (!isValidate) {
                return false;
              }
              onClickHandler("post");
            }}
          >
            Post
          </Button>
        </>
      )}
      {useFor == "approval" && (
        <>
          <Button
            type="button"
            className="submitBtn"
            onClick={(e) => setIsRejectPopupOpen(true)}
          >
            Reject
          </Button>
          <Button
            type="button"
            className="submitBtn"
            onClick={(e) =>
              handleApproveRejectCreditNote(
                formData,
                setIsOverlayLoader,
                navigate,
                "approve"
              )
            }
          >
            Approve
          </Button>
        </>
      )}
    </div>
  );
};
export default CreditNoteButton;
